//#region Util Imports

import * as _ from 'underscore'

//#endregion

import { Enums } from '../../../../models/common'
import { OpRoute } from '../../../../models/core'
import { IOpObject } from '../../../../models/util/interfaces'

import { CommonHelper } from '../../../../helpers/common-helper'
import { LocalizationHelper, EventsNames } from '../../../../helpers'

import { RouteService } from '../../../../services/route'

import { CreateEditScope, CreateEditController } from '../../../common/common.create-edit.controller'
import { CreateEditInitParams, BulkEditInitParams } from '../../../common/create-edit-popup/create-edit-popup.controller'
import { PopupType } from '../../../../helpers/popup-manager'


export class RouteCreateEditController extends CreateEditController {

    //#region Ctor

    public constructor(
        private $scope: CreateEditScope,
        private $q: ng.IQService,
        private $timeout: ng.ITimeoutService,
        private routeService: RouteService,
        protected referenceType: Enums.ReferenceType,
        private moduleName: Enums.SimaxModuleName
    ) {
        super(referenceType)

        this.setEvents()
        this.setOptions()
    }

    //#endregion


    //#region Events

    public onInit(args: any[]): void {
        const createEditInitParams: CreateEditInitParams = _.first(args)

        if (createEditInitParams != null) {
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.CREATE_EDIT_POPUP)
            this.$scope.popupType = PopupType.CREATE_EDIT_POPUP

            if (createEditInitParams.referenceObject && createEditInitParams.referenceObject.idObject > 0) {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__EDITING, this.moduleName)
            } else {
                this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__ADDING, this.moduleName)
            }

            this.$timeout(() => {
                this.$scope.$broadcast(EventsNames.OPEN_CREATE_EDIT_POPUP, createEditInitParams, 1)
            })
        }
    }

    public onInitBulk(args: any[]): void {
        const bulkEditInitParams: BulkEditInitParams = _.first(args)

        if (bulkEditInitParams != null) {
            this.$scope.$broadcast(EventsNames.SHOW_CREATE_EDIT_POPUP, PopupType.BULK_EDIT_POPUP)

            this.$scope.options.title = LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__MASS_EDITING, this.moduleName)
            this.$scope.popupType = PopupType.BULK_EDIT_POPUP

            if (args && args[0]) {
                this.$scope.gridData = args[0]
            }

            if (args && args[1]) {
                this.$scope.gridColumns = args[1]
            }

            this.$scope.$broadcast(EventsNames.OPEN_BULK_EDIT_POPUP, bulkEditInitParams)
        }
    }

    public onSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = this.$q.defer<IOpObject>()
        const routeToSave: OpRoute = this.routeService.createRouteFromIOpObject(objectToSave)

        this.routeService
            .saveRoute(routeToSave)
            .then((savedObject: OpRoute) => {
                this.$scope.$root.$broadcast(EventsNames.CLOSE_CREATE_EDIT_POPUP, savedObject)

                deferred.resolve(savedObject)
            })
            .fail((error: any) => {

                deferred.reject(error)
            })

        return deferred.promise
    }

    public onBulkSave(objectToSave: IOpObject): ng.IPromise<IOpObject> {
        const deferred: ng.IDeferred<IOpObject> = this.$q.defer<IOpObject>()
        const routeToSave: OpRoute = this.routeService.createBulkRouteFromIOpObject(objectToSave)

        this.routeService
            .saveRoute(routeToSave, true)
            .then((savedObject: OpRoute) => {
                deferred.resolve(savedObject)
            })
            .fail((error: any) => {
                deferred.reject(error)
            })

        return deferred.promise
    }

    //#endregion


    //#region Setup

    public setEvents(): void {
        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_CREATE_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInit(args)
        )

        this.$scope.$on(
            EventsNames.getEventNameByModule(Enums.SimaxEventCategory._MODULE_NAME__OPEN_BULK_EDIT_POPUP, this.moduleName),
            (event: ng.IAngularEvent, ...args: any[]) => this.onInitBulk(args)
        )
    }

    public setOptions(): void {
        this.$scope.popupVisible = false
        this.$scope.options = {
            localStorageVarForSavedEntity: CommonHelper.localStorageVarForSavedEntity.routeSaved,
            onClose: null,
            referenceType: this.referenceType,
            succsessMessage: LocalizationHelper.getLocalizedTextByModule(Enums.SimaxLocalizationCategory._MODULE_NAME__SAVED, this.moduleName),
            title: "",
            onSubmit: null,//DO USUNIECIA!!!
            submitBulkEdit: null,//DO USUNIECIA!!!
            type: PopupType.ROUTE_POPUP,//NIE UŻYWAĆ!!!

            onSave: (objectToSave: IOpObject) => { return this.onSave(objectToSave) },
            onBulkSave: (objectToSave: IOpObject) => { return this.onBulkSave(objectToSave) },
        }
    }

    //#endregion
}